import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';
import { BuggyTracker } from '../models/buggyTrackerModels';

export const useTrackingService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getBuggyLocation = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/buggytracker/site/${id}`);
        return res.data;
    };

    const createorUpdateBuggytrackerDetails = async (
        siteId: string,
        freq: string,
    ): Promise<BuggyTracker> => {
        const res = await axios.post(
            `${apiUrl}/buggytracker/site/${siteId}/frequency/${freq}`,
            null,
        );
        return res.data;
    };

    const getBuggyTrackerDetails = async (): Promise<BuggyTracker> => {
        const res = await axios.get(`${apiUrl}/buggytracker`);
        return res.data;
    };

    const deleteBuggyTrackerDetails = async (): Promise<BuggyTracker> => {
        const res = await axios.deleteId(`${apiUrl}/buggytracker`);
        return res.data;
    };

    return {
        getBuggyLocation,
        getBuggyTrackerDetails,
        createorUpdateBuggytrackerDetails,
        deleteBuggyTrackerDetails,
    };
};
